import React from 'react'
import Block from "../styled/Block";
import Text from "../styled/Text";

const FormItem = ({ children, title = "", errMsg }) => {
  return (
    <Block mb={15} err>
      {title && (
        <Block mb={3}>
          <Text>{title}</Text>
        </Block>
      )}
      <Block>{children}</Block>
      {errMsg && (
        <Block mt={2}>
          <Text size="ml" color="error">{errMsg}</Text>
        </Block>
      )}
    </Block>
  );
};

export default FormItem;
